import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import BusinessForward from './BusinessForward';
import {
	addForwards, editForwards, deleteForwards, formatPhone,
	formatPhoneNatOrIntl
} from '../redux/FeedbackRedux';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import Bar from "./Bar";

class FeedbackSettingsForwards extends React.Component {
	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleRecChange(uuid, event) {
		this.props.dispatch(editForwards({ uuid: uuid, text: formatPhone(event.target.value), type: 'recipient' }));
	}
	handleNameChange(uuid, event) {
		this.props.dispatch(editForwards({ uuid: uuid, text: event.target.value, type: 'nickname' }));
	}
	handleEmailChange(uuid, event) {
		this.props.dispatch(editForwards({ uuid: uuid, text: event.target.value, type: 'email' }));
	}
	handleClick(event) {
		event.preventDefault();
		this.props.dispatch(addForwards());
	}
	handleDelete(uuid, event) {
		event.preventDefault();
		this.props.dispatch(deleteForwards({ uuid: uuid }));
	}
	formatPhone(value) {
		formatPhone(value);
	}
	handleSubmit(event) {
		console.log("handle submit");
		var valid = true;
		var current_items = [];
		//do checks.. good stuff doesn't get prevent default
		this.props.state.business_forwards.forEach((item, key) => {
			var phone = parsePhoneNumberFromString(item.recipient, "US");
			var formatted = formatPhoneNatOrIntl(item.recipient);
			var email = item.email;
			console.log("checking ");
			console.log(item);
			console.log(formatted);
			if (((!phone || !phone.isValid()) && !email) || phone && !phone.isValid()) {
				valid = false;
				console.log("INvalid Number");
				this.props.dispatch(editForwards({ uuid: item.uuid, text: __("Please enter a valid phone number."), type: 'recipient_error' }));
			}
			else if (current_items.includes(formatted)) {
				valid = false;
				this.props.dispatch(editForwards({ uuid: item.uuid, text: __("Please enter a non-duplicate phone number."), type: 'recipient_error' }));
			}
			else if (item.recipient_error) {
				this.props.dispatch(editForwards({ uuid: item.uuid, text: false, type: 'recipient_error' }));
			}
			current_items.push(formatted);
			console.log("Current items");
			console.log(current_items);

		});

		if (!valid) {
			event.preventDefault();
		}

	}
	render() {
		return (
			<form className="tags-form" method="post" onSubmit={this.handleSubmit} action={"/business/" + this.props.state.business.business_id + "/forward-contacts"}>
				<input type="hidden" name="_token" className="makecsrf" />
				<input type="hidden" name="business_id" className="business_id" value={this.props.state.business.business_id} />
				<Bar middleCenter mobileColumn>
					<p className='mb-0 w-100 mx-3'>{__('On this page you can add/edit/delete recipients that you would like to be able to quickly forward Feedbacks to (from the Feedback History page). These recipients will be available to choose from when you select "Forward Via Text Message" on a particular Feedback.')}</p>
					<span className='text-primary mr-2 flex-shrink-0 save-change-alert mt-1 ml-auto'>{__('Changes Made, Please Save The Changes')}</span>
					<button className='btn btn-primary text-nowrap mt-1 ml-auto' type='submit'>
						<i className='fas fa-save mr-1' />
						{__('Save Changes')}
					</button>
				</Bar>

				<div className="p-3">
					<div className="card mt-4">
						<div className='title d-flex align-items-center px-3 py-2'>
							<h4 className='mb-0'>{__('Recipients')}</h4>
							<button className='btn btn-primary ml-5' onClick={this.handleClick.bind(this)} type="button">
								<i className='fas fa-plus-circle mr-1' />{__('Add Recipient')}
							</button>
						</div>
						<div className="card-body">
							{[...this.props.state.business_forwards].sort((item1, item2) => {
								if (item1.id == null) return -1;
								if (item2.id == null) return 1;
								return item1.id - item2.id;
							}).map((value, index) => {
								return (
									<BusinessForward key={value.uuid} forward={value} formatPhone={this.formatPhone.bind(this)} uuid={value.uuid} delete={this.handleDelete.bind(this, value.uuid)} changeRec={this.handleRecChange.bind(this, value.uuid)} changeName={this.handleNameChange.bind(this, value.uuid)} changeEmail={this.handleEmailChange.bind(this, value.uuid)} />
								);
							})}
						</div>
					</div>
				</div>
				<div className="d-flex justify-content-center">
					<button className='btn btn-primary text-nowrap' type='submit'>
						<i className='fas fa-save mr-1' />
						{__('Save Changes')}
					</button>
				</div>
			</form>

		);
	}
}

function mapStateToProps(state) {
	return { state: state }
}

export default connect(mapStateToProps)(FeedbackSettingsForwards);
